module.exports = __webpack_public_path__ + "static/media/logo_simple_black.9c6a1935.svg";